// RunStep — triggers run; shows validation issues (F2.2-F2.4, F3.1, F12.2). Step 7.

import { useActiveValuation, useStore, useRunStatus, useValidationIssues } from '../../store/selectors';
import { ValidationBanner } from '../common/ValidationBanner';
import { computeStepValidation, allPriorStepsValid } from '../../store';

export function RunStep() {
  const active = useActiveValuation();
  const runValuation = useStore((s) => s.runValuation);
  const { status } = useRunStatus();
  const navigate = useStore((s) => s.navigate);
  const issues = useValidationIssues(active?.valuationId ?? null);

  if (!active) return null;

  const priorValid = allPriorStepsValid(active, 6);
  const step7 = computeStepValidation(7, active);
  const result = active.result;
  const failed = result && (!result.reconciled || !result.solver.converged);

  return (
    <div className="card">
      <div className="card-title">Run Valuation</div>
      {!priorValid && (
        <p className="badge badge-warning">Resolve prior steps before running.</p>
      )}
      <ValidationBanner issues={issues} />
      <div className="row-3 mt-4">
        <button
          type="button"
          className="btn btn-primary"
          disabled={!priorValid || !step7.valid || status === 'running'}
          onClick={() => runValuation(active.valuationId)}
        >
          {status === 'running' ? 'Running…' : 'Run Valuation'}
        </button>
        {result && result.reconciled && result.solver.converged && (
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => navigate('results')}
          >
            View Results →
          </button>
        )}
      </div>
      {failed && (
        <p className="badge badge-error mt-3">
          Solver did not converge or reconciliation failed — review inputs and re-run.
        </p>
      )}
    </div>
  );
}
